import { Box, styled } from '@mui/material';

import { COLORS } from '../../../configs/colors';
import { BottomSheetHeight } from './BottomSheet.props';

const HEIGHT_MAP: Record<BottomSheetHeight, string> = {
  small: '40vh',
  medium: '60vh',
  large: '85vh',
};

interface SheetContainerProps {
  sheetHeight: BottomSheetHeight;
}

export const SheetContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'sheetHeight',
})<SheetContainerProps>(({ sheetHeight }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  maxHeight: HEIGHT_MAP[sheetHeight],
  backgroundColor: COLORS.White,
  borderRadius: '16px 16px 0 0',
  display: 'flex',
  flexDirection: 'column',
  zIndex: 1300,
  paddingBottom: 'calc(24px + env(safe-area-inset-bottom))',
}));

export const DragHandle = styled(Box)({
  width: 40,
  height: 4,
  backgroundColor: COLORS.SubtleGrey,
  borderRadius: 2,
  margin: '8px auto',
});

export const SheetHeader = styled(Box)({
  padding: '8px 16px 12px',
  borderBottom: `1px solid ${COLORS.SubtleGrey}`,
});

export const SheetTitle = styled(Box)({
  fontSize: 18,
  fontWeight: 600,
  color: COLORS.NavyBlue,
});

export const SheetSubtitle = styled(Box)({
  fontSize: 13,
  color: COLORS.Gray,
  marginTop: 2,
});

export const SheetContent = styled(Box)({
  flex: 1,
  overflowY: 'auto',
  WebkitOverflowScrolling: 'touch',
  paddingBottom: 24,
});

export const SheetFooter = styled(Box)({
  display: 'flex',
  gap: 12,
  padding: '12px 16px',
  borderTop: `1px solid ${COLORS.SubtleGrey}`,
});

export const Overlay = styled(Box)({
  position: 'fixed',
  inset: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  zIndex: 1299,
});
